<template>
  <el-row>
    <!-- 左侧树状结构 -->
    <el-col :span="5">
      <basic-container>
        <SideTree
          :permissionList="permissionList"
          :apis="treeApis"
          @updateTreeNode="resetTableData"
        ></SideTree>
      </basic-container>
    </el-col>
    <!-- 右侧crud -->
    <el-col :span="19">
      <basic-container>
        <avue-crud
          v-show="projectId"
          ref="crud"
          :option="tableOption"
          :table-loading="loading"
          :data="tableData"
          :page.sync="tablePage"
          :search.sync="searchForm"
          @search-change="searchChange"
          @search-reset="searchReset"
          @refresh-change="loadData"
          @on-load="loadData"
        >
          <template slot="menuLeft">
            <el-button
              v-if="permissionList.addBtn"
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="openDialog('add')"
            >
              新增
            </el-button>
          </template>
          <template slot-scope="{ row }" slot="menu">
            <el-button
              v-if="permissionList.viewBtn"
              type="text"
              size="small"
              @click="viewFile(row)"
            >
              查看
            </el-button>
            <el-button
              v-if="permissionList.editBtn"
              type="text"
              size="small"
              @click="openDialog('edit', row)"
            >
              编辑
            </el-button>
            <el-button v-if="permissionList.delBtn" type="text" size="small" @click="doDel(row)">
              删除
            </el-button>
          </template>
        </avue-crud>
        <!-- 弹框 -->
        <el-dialog
          :title="dialogTitle"
          width="60%"
          :visible.sync="isDialogShow"
          :before-close="beforeCloseDialog"
          :append-to-body="true"
          :modal-append-to-body="true"
          :close-on-click-modal="false"
          :destroy-on-close="true"
        >
          <Form
            v-if="isDialogShow"
            :dialogType="dialogType"
            :rowData="rowData"
            :apis="formApis"
            :projectId="projectId"
            @update="updateTableDataSuccess"
            @close="beforeCloseDialog"
          ></Form>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import SideTree from '../../components/side-tree';
import Form from '../components/form';
import { mapGetters } from 'vuex';
import { onlinePreviewFile } from '../../common';
import {
  getPageListApi,
  addApi,
  updateApi,
  delApi,
  detailApi,
  treeListApi,
  treeAddApi,
  treeUpdateApi,
  treeDelApi,
} from '@/api/call-system/knowledge-manage/data-manage';

export default {
  components: { SideTree, Form },
  data() {
    return {
      projectId: '', // 项目id
      selectedTreeData: null, // 选中的树节点对应的数据
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      loading: false, // 是否正在加载数据
      searchForm: {}, // 搜索表单
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 18,
        searchLabelWidth: 80,
        column: [
          {
            label: '文件标题',
            prop: 'title',
            search: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '文件类型',
            prop: 'extension',
          },
          {
            label: '文件说明',
            prop: 'content',
          },
          {
            label: '发布人',
            prop: 'userName',
          },
          {
            label: '发布时间',
            prop: 'createTime',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.callSystem_knowledgeManage_dataManage_add, false),
        delBtn: this.vaildData(this.permission.callSystem_knowledgeManage_dataManage_del, false),
        editBtn: this.vaildData(this.permission.callSystem_knowledgeManage_dataManage_edit, false),
        viewBtn: this.vaildData(this.permission.callSystem_knowledgeManage_dataManage_view, false),
        addCatalog: this.vaildData(
          this.permission.callSystem_knowledgeManage_dataManage_addCatalog,
          false
        ),
        delCatalog: this.vaildData(
          this.permission.callSystem_knowledgeManage_dataManage_delCatalog,
          false
        ),
        editCatalog: this.vaildData(
          this.permission.callSystem_knowledgeManage_dataManage_editCatalog,
          false
        ),
      };
    },
    treeApis() {
      return {
        list: treeListApi,
        add: treeAddApi,
        update: treeUpdateApi,
        del: treeDelApi,
      };
    },
    formApis() {
      return {
        add: addApi,
        update: updateApi,
      };
    },
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 337; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.projectId) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign(
          {
            projectId: this.projectId,
            menuId: this.selectedTreeData.id,
            current: page.currentPage,
            size: page.pageSize,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {};
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 重置表格数据 */
    resetTableData(data) {
      this.projectId = data.projectId;
      this.selectedTreeData = data.nodeData;
      this.tableData = [];
      this.tablePage.currentPage = 1;
      this.tablePage.total = 0;
      this.loadData();
    },
    /* CRUD更新表格数据 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 删除 */
    doDel(row) {
      this.$confirm('确认删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return delApi({
            ids: row.id,
          });
        })
        .then(() => {
          this.$message.success('操作成功!');
          this.loadData();
        });
    },
    /* 查看 */
    viewFile(row) {
      detailApi({
        id: row.id,
      }).then(({ data }) => {
        onlinePreviewFile(data.attachList[0].link);
      });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        edit: '编辑',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = true;
      if (type == 'add') {
        this.rowData = {
          projectId: this.projectId,
          menuId: this.selectedTreeData.id,
          menuName: this.selectedTreeData.name,
        };
        this.isDialogShow = true;
      } else {
        detailApi({
          id: this.rowData.id,
        }).then(({ data }) => {
          this.rowData = data;
          this.isDialogShow = true;
        });
      }
    },
    /* 关闭弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
